import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79661086"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-wrap" }
const _hoisted_2 = { class: "title xag-flex-lr" }
const _hoisted_3 = {
  key: 0,
  class: "wait-text"
}

import { withDefaults } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'block-wrap',
  props: {
    title: { default: '' },
    waitText: { default: '' }
  },
  setup(__props: any) {

const props = __props as { title: string, waitText: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(props.title), 1),
      _renderSlot(_ctx.$slots, "right")
    ]),
    _renderSlot(_ctx.$slots, "default"),
    (props.waitText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.waitText), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})